const TmpI002 = (page, section) => {
  // build out the transcript from the core content segments
  let transcript = '';
  page.content.core.forEach((segment, index) => {
    if (index === 0) {
      transcript += segment.text_en;
    } else {
      transcript += ' ' + segment.text_en;
    }
  });

  // build out the media object from the page data
  const media = {
    id: page.id,
    page: page.id,
    author: 'Team ACV/AAC',
    author_desc_en: 'Team ACV/AAC',
    author_desc_tl: 'N/A',
    cc_license: 'N/A',
    description: page.content.description || 'MISSING DESCRIPTION',
    downloaded_date: new Date().toISOString(),
    published_date: new Date().toISOString(),
    media_url:
      'https://base-media-repo.web.app/' +
      page.label.slice(0, 2).toUpperCase() +
      '/video/' +
      page.label.toLowerCase().replaceAll('-', '_') +
      '.mp4',
    source_url: 'Team ACV/AAC',
    src: page.label.toLowerCase().replaceAll('-', '_') + '.mp4',
    title_en: 'N/A',
    title_tl: 'N/A',
    transcript: transcript,
    type: 'video'
  };

  const ccData = [];
  page.content.core.forEach((segment) => {
    const cc = {
      id: segment.id,
      text: segment.text_en,
      start_minute: segment.start_minute,
      start_second: segment.start_second,
      end_minute: segment.end_minute,
      end_second: segment.end_second
    };
    ccData.push(cc);
  });

  const modifiedPage = {
    ...page,
    content: {
      is_en: true,
      cc: ccData || [],
      media: media
    }
  };

  // remove eMentor content from the modified page
  if (modifiedPage.content.eMentor) {
    delete modifiedPage.content.eMentor;
  }

  // Extract metadata separately
  const metadata = {
    media: [media] || [],
    images: [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpI002;
